import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import GlobalData from './global/global-data.js'
import GlobalMethods from './global/global-methods.js'
import mixins from './global/mixins'
import datePicker from 'vue-bootstrap-datetimepicker';
import BackToTop from 'vue-backtotop'
import 'bootstrap/dist/css/bootstrap.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import VueSingleSelect from "vue-single-select"
import Vue2TouchEvents from 'vue2-touch-events'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import StarRating from 'vue-star-rating'

import PopulateForm from './components/Common/PopulateForm'
import Chat from 'vue-beautiful-chat'
import VueBarcodeScanner from 'vue-barcode-scanner'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'

import Alert from '@/plugins/alert.js'

// import { BOverlay } from 'bootstrap-vue'

// 載入vue2-leaflet，依照自己需要載入組件
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

library.add(fas)
library.add(far)
library.add(fab)

Vue.config.productionTip = false

// 啟用載入的各組件 (leaflet)
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-popup", LPopup);
Vue.component("l-icon", LIcon);

// 共用的global資料和事件方法切到獨立的js來撰寫,引用時再用...展開即可
// Vuex晚點再導入吧
const EventBus = new Vue(
  {
    data: {
      ...GlobalData
    },
    created: function () {
      // input組件本身的鍵盤滑鼠事件可以各自bind即可,但全域的便利快速鍵,就集中在這裡定義(每個事件搭配一個method)
      // window.addEventListener('keyup', this.handleKeyUp)
    },
    methods: {
      ...GlobalMethods
    }
  }
)
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

Vue.mixin(mixins)
Vue.use(BootstrapVue)
Vue.use(datePicker)
Vue.use(BackToTop)
Vue.use(Vue2TouchEvents)
Vue.use(Chat)
Vue.use(VueBarcodeScanner)
// 使用VueAxios
Vue.use(VueAxios, axios)
// 彈窗套件 
Vue.use(VueSweetalert2);

// 自製的訊息框
Vue.use(Alert)


// inject barcode scanner with option (add sound effect)
// sound will trigger when it's already scanned
let options = {
  sound: true, // default is false
  soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 300, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}
Vue.use(VueBarcodeScanner, options)


Vue.component('vue-single-select', VueSingleSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('star-rating', StarRating)
Vue.component('populate-form', PopulateForm)
// Vue.component('b-overlay', BOverlay)



// 設定預設icon (leaflet)
import { Icon } from "leaflet";
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app')
